import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@apollo/client';
import * as yup from 'yup';
import LookupInput from './TailLookupInput';
import OperatorLookupInput from '../../operators/lookup/OperatorLookupInput';
import FoundTail from './FoundTail';
import FoundOperator from '../../operators/lookup/FoundOperator';
import styled from 'styled-components';
import {
  titleColor,
  buttonBackground,
  informationText,
  titleBackground,
} from '../../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

`;

const Row = styled.div`
  padding-left: 1rem;
`;

const H2 = styled.h2`

`;

const Banner = styled.h1`
  display: flex;
  flex: 1;
  background-color: #E1EFFF;
  color: #00518E;
  border-radius: 10px;
  padding: 15px;
  padding-left: 1rem;
`;

export const TitleContainer = styled.div`
  height: 100px;
  border-radius: 16px;
  background-color: ${titleBackground};
  display: flex;
  margin-bottom: 80px;

  @media (max-width: 600px) {
    height: 60px;
  }
`;

export const Title = styled.div`
  color: ${buttonBackground};
  font-size: 2rem;
  font-weight: 700;
  align-self: center;
  margin-left: 32px;

  @media (max-width: 600px) {
    font-size: 1.3rem;
  }
`;

const Text = styled.div`
  color: #898989;
`;

const HelpLink = styled.div`
  margin-top: 25px;
`;

const ImageContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 30px;
`;

const FoundTailContainer = styled.div`
  margin-top: 2rem;
`;

const TailLookup = (props) => {
  const [currentInput, setCurrentInput] = useState()
  const [foundTail, setFoundTail] = useState('');
  const [foundTailNumberBackup, setFoundTailNumberBackup] = useState('');
  const [foundOperator, setFoundOperator] = useState('');
  const [foundOperatorBackup, setFoundOperatorBackup] = useState('');
  const [term, setTerm] = useState('');
  const [notFound, setNotFound] = useState(false);

  const displayResult = () => {
    // if(!optionClicked) {
    //   return (
    //     <Row className="row">
    //       <div className="col-md-12">
    //         <h2>No Tails Found</h2>
    //       </div>
    //     </Row>
    //   )
    // }else if (optionClicked && foundTail !== '') {
    if (currentInput === 'tail' && foundTail !== '') {
      return (
        <Row className="row">
          <div className="col-md-12">
            <FoundTailContainer>
              <FoundTail foundTail={foundTail} />
            </FoundTailContainer>
          </div>
        </Row>
      )
    }else if(currentInput === 'operator' && foundOperator !== '') {
      return (
        <Row className="row">
          <div className="col-md-12">
            <FoundTailContainer>
              <FoundOperator foundOperator={foundOperator} />
            </FoundTailContainer>
          </div>
        </Row>
      )
    }else {
      return null
    }
  }

  const HeaderContent = () => {
    return (
      <>
        <div className="row">
          <TitleContainer className="col-md-12">
            <Title>
              Tail Number and Operator Lookup
            </Title>
          </TitleContainer>
        </div>
        <Row className="row">
          <div className="col-md-6">
            <H2>
              Enter a Tail Number or Operator Name
            </H2>
          </div>
        </Row>
        <Row className="row">
          <div className="col-md-12">
            <Text>
              Enter a tail number or operator name to check whether an aircraft
              is part of the Fly Louie Fuel Program.
            </Text>
          </div>
        </Row>
      </>
    )
  }

  const TailLookupContent = () => {
    return (
      <Container className="container">
        <Row className="row">
          <div className="col-md-12">
            <LookupInput
              foundTail={foundTail}
              setFoundTail={setFoundTail}
              setFoundOperator={setFoundOperator}
              currentInput={currentInput}
              setCurrentInput={setCurrentInput}
              foundTailNumberBackup={foundTailNumberBackup}
              setFoundTailNumberBackup={setFoundTailNumberBackup}
            />
          </div>
        </Row>
      </Container>
    )
  }

  const OperatorLookupContent = () => {
    return (
      <Container className="container">
        <Row className="row">
          <div className="col-md-12">
            <OperatorLookupInput
              foundOperator={foundOperator}
              setFoundOperator={setFoundOperator}
              setFoundTail={setFoundTail}
              currentInput={currentInput}
              setCurrentInput={setCurrentInput}
              foundOperatorBackup={foundOperatorBackup}
              setFoundOperatorBackup={setFoundOperatorBackup}
            />
          </div>
        </Row>
      </Container>
    )
  }

  const FooterContent = () => {
    return (
      <>
        <Row className="row">
          <div className="col-md-6">
            <HelpLink>
              <a href='/howToSpot'>
                Other Ways to Identify a Fly Louie Aircraft
              </a>
            </HelpLink>
          </div>
        </Row>
        <Row className="row">
          <div className="col-md-6">
            <HelpLink>
              <a href='/assistance'>Need Help? Click for Immediate Assistance</a>
            </HelpLink>
          </div>
        </Row>
        <br />
      </>
    )
  }

  const DisplayContent = () => {
    return (
      <div>
        <HeaderContent />
        <TailLookupContent />
        <OperatorLookupContent />
        {displayResult()}
        <FooterContent />
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>Lookup Tail or Operator</title>
      </Helmet>
      <DisplayContent />
    </>
  )
}

export default TailLookup;
